/* eslint-disable import/prefer-default-export */
export const baseInvoiceFilters = {
  siiStatus: [],
  creditNoteStatus: [],
  documentType: [],
  documentFinanceStatus: [],
};
